'use strict';

import * as THREE from "three";
import {FBXLoader} from "three/examples/jsm/loaders/FBXLoader";
import {isMobile, settingsData} from "../../settings";
import {getCookie, setCookie} from "../cookies/setAndGetCookies";
import {changeBorderRadius, createElements} from "../../functions";
import {SwipeScript} from "../controls/swipe";
import {CardTypes, ViewMode} from "../../common";

let environmentShow = true;

export const leftNavigationBar = ({environment}) => {
    optionsMenu();
    liveToggler();
}

function optionsMenu() {
    const containerLeft = createElements('div', ['left-nav-bar', 'non-canvas'], document.body);
    const buttonsWrapper = createElements('div', ['buttons-wrapper'], containerLeft);
    const options = createElements('button', ['button-options'], buttonsWrapper);
    options.classList.add('icon-tune');
    const containerMenu = createElements('div', ['options__menu', 'non-canvas'], document.body);
    const searchBtn = document.querySelector('.filter-module-open-btn');
    const miniCard = document.querySelector('.popup-info');

    options.setAttribute('data-type', CardTypes.Options);

    buttonsWrapper.addEventListener('click', function(event) {
        const btn = event.target;
        let btnType = btn.getAttribute('data-type');
        if (!btnType) {
            btnType = btn.parentNode.getAttribute('data-type');
        }

        if (containerMenu.classList.contains('open')) {
            const wrapper = document.querySelector('.options__menu-wrapper');
            containerMenu.classList.remove('open');
            wrapper.remove();

            return;
        }

        switch (btnType) {
            case CardTypes.Options: {
                document.body.setAttribute('data-swipe-ignore', 'true');

                containerMenu.classList.add('open');
                settingsData.enableAutorotation = false;

                document.querySelector('.three_js').addEventListener('click', closeOptionsMenu);
                document.querySelector('.three_js').addEventListener('touchstart', closeOptionsMenu);

                function closeOptionsMenu() {
                    containerMenu.classList.remove('open');
                    document.body.removeAttribute('data-swipe-ignore');
                    setTimeout(() => {
                        containerMenu.innerHTML = '';
                    }, 500);

                    if (isMobile) {
                        setOrRemoveClass('hide', 'remove', options, searchBtn, miniCard);
                    }

                    document.querySelector('.three_js').removeEventListener('click', closeOptionsMenu);
                    document.querySelector('.three_js').removeEventListener('touchstart', closeOptionsMenu);
                }

                if (isMobile) {
                    SwipeScript();
                    setOrRemoveClass('hide', 'set', options, searchBtn, miniCard);

                    containerMenu.addEventListener('swiped-down', closeCardOptions, false);

                    function closeCardOptions(e) {
                        e.preventDefault();
                        e.stopPropagation();

                        setTimeout(() => {
                            containerMenu.innerHTML = '';
                        }, 300);

                        containerMenu.classList.remove('open');
                        document.body.removeAttribute('data-swipe-ignore');

                        setOrRemoveClass('hide', 'remove', options, searchBtn, miniCard);
                        return false;
                    }
                }
                return;
            }
            default: return;
        }
    });
    changeBorderRadius(options);
}
function setOrRemoveClass(className, action, ...elements) {
    if (action === 'set') {
        elements.forEach(elem => {
            if (elem) {
                elem.classList.add(className);
            }
        });
    } else if (action === 'remove') {
        elements.forEach(elem => {
            if (elem && elem.classList.contains(className)) {
                elem.classList.remove(className);
            }
        });
    }
}
export function turnOffAllEnvironment(optionsObject) {
    if (!environmentShow && settingsData.activeViewMode === ViewMode.Cylinder) {
        return;
    }

    environmentShow = !environmentShow;

    if (!environmentShow) {
        if (optionsObject) {
            optionsObject.map(item => item.active = false);
        }
    }

    liveToggler(optionsObject);
}
function liveToggler(environmentSettings = []) {
    return;
    const loader = new FBXLoader();
    const texture_loader = new THREE.TextureLoader();

    if (getCookie('environmentBool') === 'false') {
        return;
    }

    setCookie('envOptions', JSON.stringify(environmentSettings), {'max-age': 999999});

    environmentSettings.forEach(({type, active}) => {
        switch (type) {
            case 'cars': {
                add_cars(texture_loader, loader, active ? 'add' : 'remove');
                break;
            }
            case 'pedestrians': {
                add_humans(loader, active ? 'add' : 'remove');
                break;
            }
            case 'bicycles': {
                add_bicycle(loader, active ? 'add' : 'remove');
                break;
            }
            default:
                break;
        }
    });
}

